/* ============================================================
   CC- Küchenvorschau-Funnel — Landing Page Logik
   Erstellt von Claude Code (cc-)
   - E-Mail-Validierung + Klaviyo-Subscribe (Client Subscriptions API)
   - Erfolgs-Zustand ("E-Mail mit Upload-Link" ist unterwegs)
   - FAQ-Accordion
   Config (Klaviyo company_id / Listen-ID) kommt aus data-Attributen
   der Section (gesetzt über die Theme-Editor-Einstellungen).
   ============================================================ */
(function () {
  var KLAVIYO_REVISION = '2024-10-15';

  /* Zentrales Klick-Tracking: ausschliesslich GTM dataLayer.
     Der direkte fbq('trackCustom')-Aufruf wurde am 16.08.2026 entfernt. Grund:
     Meta bekommt das Lead-Event bereits ueber den GTM-Tag "Facebook Pixel ||
     Lead" (Standard-Event "Lead"). Seit dieser Tag den Pixel selbst nachlaedt,
     war fbq plotzlich definiert und die Zeile feuerte zusaetzlich das
     Custom-Event "cc_lp_email_submit" — also jede Absendung doppelt gemeldet.
     Ausserdem wuerde sie ab jetzt die E-Mail (siehe cc_email unten) im
     KLARTEXT als Event-Parameter an Meta schicken; fuer Advanced Matching
     gehoert sie gehasht in die user_data, das erledigt der GTM-Tag. */
  function ccTrack(event, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
  }

  function validEmail(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || '').trim());
  }

  /* Fügt die E-Mail einer Klaviyo-Liste hinzu. Der eigentliche Versand
     der Mail mit Upload-Link läuft über einen Klaviyo-Flow (Trigger:
     "zu Liste hinzugefügt"). Gibt ein Promise zurück. */
  function klaviyoSubscribe(companyId, listId, email, sourceLabel) {
    if (!companyId || !listId) {
      // Noch nicht konfiguriert: nicht blockieren, aber sichtbar loggen.
      console.warn('[cc-funnel] Klaviyo company_id oder Listen-ID fehlt — E-Mail wurde NICHT übermittelt. Bitte in den Section-Einstellungen eintragen.');
      return Promise.reject(new Error('klaviyo-config-missing'));
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      // keepalive: der Browser bricht laufende Requests beim Seitenwechsel ab. Ohne das
      // ging die Adresse verloren, sobald direkt zur Upload-Seite weitergeleitet wurde
      // (Alwin, 14.08.2026: Eintrag kam nie in Klaviyo an).
      keepalive: true,
      headers: {
        'revision': KLAVIYO_REVISION,
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: sourceLabel || 'Küchenvorschau-Funnel',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: (email || '').trim() }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      })
    }).then(function (res) {
      if (!res.ok && res.status !== 202) {
        throw new Error('klaviyo-http-' + res.status);
      }
      return res;
    });
  }

  /* Onsite-Tracking (falls Klaviyo-Onsite-Snippet geladen ist) */
  function klaviyoIdentify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: (email || '').trim() });
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['identify', { $email: (email || '').trim() }]);
      }
    } catch (e) { /* still stumm */ }
  }

  function showSuccess(root) {
    root.querySelectorAll('[data-cc-lp-capture]').forEach(function (el) { el.classList.add('cc-lp-hidden'); });
    root.querySelectorAll('[data-cc-lp-success]').forEach(function (el) { el.classList.remove('cc-lp-hidden'); });
  }

  function bindForm(root, form) {
    var companyId = root.getAttribute('data-klaviyo-company') || '';
    var listId = root.getAttribute('data-klaviyo-list') || '';
    var source = root.getAttribute('data-klaviyo-source') || 'Küchenvorschau-Funnel';

    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-cc-lp-error]');
    var submitBtn = form.querySelector('[type="submit"], [data-cc-lp-submit]');

    function clearError() {
      if (errEl) { errEl.textContent = ''; errEl.classList.add('cc-lp-hidden'); }
      if (input) input.classList.remove('cc-lp-input--error');
    }
    function setError(msg) {
      if (errEl) { errEl.textContent = msg; errEl.classList.remove('cc-lp-hidden'); }
      if (input) input.classList.add('cc-lp-input--error');
    }

    if (input) input.addEventListener('input', clearError);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input ? input.value : '';
      if (!validEmail(email)) {
        setError('Bitte gib eine gültige E-Mail-Adresse ein, damit wir Dir Deine Vorschau später zuschicken können.');
        if (input) input.focus();
        return;
      }
      clearError();
      if (submitBtn) { submitBtn.setAttribute('disabled', ''); submitBtn.textContent = 'Einen Moment…'; }
      /* cc_email geht NUR in den dataLayer (bleibt im Browser). Der GTM-Tag
         "Facebook Pixel || Lead" liest sie fuer Advanced Matching aus und
         uebergibt sie an den Pixel, der sie vor dem Senden hasht (SHA-256).
         Klartext verlaesst den Browser dadurch nicht. */
      ccTrack('cc_lp_email_submit', { funnel_step: 'landing_email', cc_email: email.trim().toLowerCase() });
      klaviyoIdentify(email);

      var uploadUrl = root.getAttribute('data-upload-url') || '';
      function weiter() {
        if (uploadUrl) {
          // Merker fuer die Upload-Seite: nur auf diesem Weg gehoert der gruene
          // "E-Mail eingetragen"-Balken dorthin (nicht beim Klick aus der Mail).
          try { sessionStorage.setItem('cc_funnel_from_landing', '1'); } catch (e) {}
          window.location.href = uploadUrl + (uploadUrl.indexOf('?') >= 0 ? '&' : '?') + 'email=' + encodeURIComponent(email);
        } else {
          showSuccess(root); // Fallback, falls keine Upload-URL gesetzt
          if (submitBtn) submitBtn.removeAttribute('disabled');
        }
      }

      // Erst absenden, dann weiterleiten. Vorher lief beides gleichzeitig — der Browser
      // verwarf den Klaviyo-Request beim Seitenwechsel und die Adresse war weg.
      // Das Zeitlimit sorgt dafuer, dass niemand auf ein haengendes Klaviyo wartet:
      // dank keepalive laeuft der Request dann trotzdem zu Ende.
      var weitergeleitet = false;
      function einmalWeiter() { if (!weitergeleitet) { weitergeleitet = true; weiter(); } }
      setTimeout(einmalWeiter, 2500);
      klaviyoSubscribe(companyId, listId, email, source)
        .catch(function (err) { console.error('[cc-funnel] Klaviyo-Subscribe fehlgeschlagen:', err); })
        .then(einmalWeiter);
    });
  }

  function bindAccordion(root) {
    var items = root.querySelectorAll('[data-cc-acc-item]');
    items.forEach(function (item, idx) {
      var q = item.querySelector('[data-cc-acc-q]');
      var a = item.querySelector('[data-cc-acc-a]');
      if (!q || !a) return;

      function open() { item.setAttribute('aria-expanded', 'true'); a.style.maxHeight = a.scrollHeight + 'px'; }
      function close() { item.setAttribute('aria-expanded', 'false'); a.style.maxHeight = '0px'; }

      q.addEventListener('click', function () {
        var isOpen = item.getAttribute('aria-expanded') === 'true';
        // Klassisches Accordion: andere schließen
        items.forEach(function (other) {
          if (other !== item) {
            other.setAttribute('aria-expanded', 'false');
            var oa = other.querySelector('[data-cc-acc-a]');
            if (oa) oa.style.maxHeight = '0px';
          }
        });
        if (isOpen) { close(); } else { open(); }
      });

      // Erstes Item standardmäßig offen
      if (idx === 0 && item.getAttribute('data-cc-acc-default') === 'open') {
        // nach Layout öffnen, damit scrollHeight korrekt ist
        requestAnimationFrame(open);
      }
    });
  }


  // ---------- Vorher/Nachher-Slider ----------
  // Schiebt IMMER um EIN Bild weiter, auch wenn auf Desktop zwei nebeneinander stehen
  // (CSS-Variable --cc-per-view). Alle 3 s rückt also ein Bild nach, statt beide zu
  // tauschen (Alwin, 14.08.2026). Pausiert bei Hover, Fokus, Wischen und im Hintergrund.
  function bindSlider(slider) {
    var track = slider.querySelector('[data-cc-slider-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (slides.length < 2) return;

    // Lazy-Bilder in einem transform-Slider laedt der Browser NIE: sie stehen im DOM,
    // rutschen aber nie in den sichtbaren Bereich — der Track wird verschoben, nicht
    // gescrollt. Ohne dieses Freischalten zeigte nur der erste Slide ein Bild.
    slides.forEach(function (s, n) {
      var im = s.querySelector('img');
      if (im && n > 0) im.loading = 'eager';
    });

    var dotsWrap = slider.querySelector('[data-cc-slider-dots]');
    var prevBtn = slider.querySelector('[data-cc-slider-prev]');
    var nextBtn = slider.querySelector('[data-cc-slider-next]');
    var pos = 0, timer = null, paused = false, positions = 1, perView = 1;
    var interval = (parseFloat(slider.getAttribute('data-interval')) || 3) * 1000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function readPerView() {
      var v = parseInt(getComputedStyle(slider).getPropertyValue('--cc-per-view'), 10);
      return v > 0 ? v : 1;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (positions < 2) { dotsWrap.hidden = true; return; }
      dotsWrap.hidden = false;
      for (var n = 0; n < positions; n++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-pos', n);
        b.setAttribute('aria-label', 'Bild ' + (n + 1) + ' von ' + slides.length);
        dotsWrap.appendChild(b);
      }
    }

    function show(n) {
      pos = (n + positions) % positions;
      // Ein Schritt = eine Slide-Breite. Der Track ist so breit wie das Sichtfenster,
      // eine Slide belegt davon 100/perView Prozent.
      track.style.transform = 'translateX(' + (-pos * (100 / perView)) + '%)';
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, k) {
          d.classList.toggle('is-active', k === pos);
        });
      }
    }

    function layout() {
      var pv = readPerView();
      if (pv === perView && positions > 1) return;      // nichts geaendert
      perView = pv;
      // Letzte Position zeigt die letzten perView Bilder — danach ist rechts Schluss.
      positions = Math.max(1, slides.length - perView + 1);
      buildDots();
      show(Math.min(pos, positions - 1));
    }

    function tick() { if (!paused) show(pos + 1); }
    function start() { if (!timer && !reduced) timer = setInterval(tick, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (dotsWrap) dotsWrap.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) { show(parseInt(b.getAttribute('data-pos'), 10)); restart(); }
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(pos - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(pos + 1); restart(); });

    slider.addEventListener('mouseenter', function () { paused = true; });
    slider.addEventListener('mouseleave', function () { paused = false; });
    slider.addEventListener('focusin', function () { paused = true; });
    slider.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    var x0 = null, y0 = null;
    slider.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; paused = true;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      // Nur waagerechte Gesten werten, sonst kapert der Slider das Scrollen der Seite.
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(pos + (dx < 0 ? 1 : -1)); restart(); }
      x0 = y0 = null; paused = false;
    }, { passive: true });

    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layout, 200); });

    layout();
    show(0);
    start();
  }

  // Kurzclips in den Karten erst starten, wenn sie im Blick sind. autoplay allein
  // zusammen mit preload="none" startet nicht — der Browser hat dann nichts geladen.
  function bindCardVideos(root) {
    var vids = root.querySelectorAll('video[data-cc-autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(vids, function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  // Scroll-Hinweis: nach dem ersten Scrollen ausblenden; Klick scrollt eine Sektion weiter.
  function bindScrollCue(root) {
    var cue = root.querySelector('[data-cc-scrollcue]');
    if (!cue) return;
    cue.addEventListener('click', function () {
      var hero = cue.closest('section');
      var next = hero && hero.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    var weg = function () {
      if (window.scrollY > 60) { cue.classList.add('is-hidden'); window.removeEventListener('scroll', weg); }
    };
    window.addEventListener('scroll', weg, { passive: true });
  }

  function init(root) {
    if (!root || root.getAttribute('data-cc-init') === '1') return;
    root.setAttribute('data-cc-init', '1');
    root.querySelectorAll('[data-cc-lp-form]').forEach(function (form) { bindForm(root, form); });
    bindAccordion(root);
    root.querySelectorAll('[data-cc-slider]').forEach(bindSlider);
    bindCardVideos(root);
    bindScrollCue(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.cc-lp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
